/* eslint-disable react-hooks/exhaustive-deps */
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import {
  Button,
  Col,
  Descriptions,
  Modal,
  Row,
  Spin,
  Typography,
  Upload
} from 'antd';
import moment from 'moment';
import React, { useEffect, useState } from 'react';
import { Document, Page } from 'react-pdf';
import { SizeMe } from 'react-sizeme';
import CardDocumentPreview360 from '../../../components/CardDocumentPreview360';
import DescripcionPlan from '../../../components/DescripcionPlan';
import Image360 from '../../../components/Image360';
import {
  DescripcionesAsegurado,
  DescripcionesHogar,
  DescripcionesPersonal,
  DescripcionesVehiculo,
  getDescripcionesIngreso
} from '../../../components/SolicitudView';
import { getCarouselData, getTable, listaFormaPago } from '../../../utils';
import { instanceRef } from '../../../utils/axios';
import { formatoMonedaGenerico } from '../../../utils/converters';

const { Title } = Typography;

const Solicitud = ({ solicitud, solicitante, documentos, formularios }) => {
  const [dialogConfig, setDialogConfig] = useState(false);
  const [currentPage, setCurrentPage] = useState(0);
  const [numPages, setNumPages] = useState(null);
  const [
    documentosSinComprobanteIngreso,
    setDocumentosSinComprobanteIngreso
  ] = useState();
  const [
    documentosDeComprobanteIngreso,
    setDocumentosDeComprobanteIngreso
  ] = useState();
  const [
    documentosDeFacturasServicios,
    setDocumentosDeFacturasServicios
  ] = useState();

  const DatosProducto = () => {
    switch (solicitud.cotizacion?.id_producto) {
      case 1:
        return <DescripcionesVehiculo fields={solicitud} />;
      case 2:
        return <DescripcionesPersonal fields={solicitud} />;
      case 3:
        return <DescripcionesPersonal fields={solicitud} />;
      case 4:
        return <DescripcionesHogar fields={solicitud} />;
      case 5:
        return <DescripcionesHogar fields={solicitud} />;
      default:
        return null;
    }
  };

  function onDocumentLoadSuccess({ numPages: nextNumPages }) {
    setNumPages(nextNumPages);
  }

  const nextPage = () => {
    if (currentPage < numPages - 1) {
      setCurrentPage(currentPage + 1);
    }
  };

  const previousPage = () => {
    if (currentPage > 0) {
      setCurrentPage(currentPage - 1);
    }
  };

  const fetchDocumentos = async () => {
    try {
      if (documentos) {
        const promises = documentos.map(async (doc) => {
          const data = {
            token: doc.token,
            id: doc.id,
            tipo: doc.tipo
          };

          try {
            const response = await instanceRef.instance.post(
              `/solicitud/fileV2`,
              data
            );
            if (response && response.data) {
              const docObtenido = {
                ...data,
                url: response.data.fileBase64,
                pathS3: doc.pathS3
              };
              return docObtenido;
            }
          } catch (error) {
            // console.error('Error:', error);
          }

          return null;
        });

        const results = await Promise.all(promises);
        const filteredSinComprobantes = results.filter(
          (doc) => doc !== null && !doc.pathS3.includes('comprobanteingreso')
        );
        const filteredComprobantes = results.filter(
          (doc) => doc !== null && doc.pathS3.includes('comprobanteingreso')
        );
        const filteredFacturas = results.filter(
          (doc) => doc !== null && doc.pathS3.includes('facturaservicios')
        );
        setDocumentosSinComprobanteIngreso(filteredSinComprobantes);
        setDocumentosDeComprobanteIngreso(filteredComprobantes);
        setDocumentosDeFacturasServicios(filteredFacturas);
      }
    } catch (error) {
      // console.log(error);
    }
  };

  useEffect(() => {
    if (documentos) {
      fetchDocumentos();
    }
  }, [documentos]);

  const PreviewDocumentos = () => {
    return (
      <>
        <Title level={5} align="left" style={{ marginTop: '20px' }}>
          Documentos
        </Title>
        {documentosSinComprobanteIngreso &&
          !documentosSinComprobanteIngreso.length && <p>Sin datos</p>}
        <Row gutter={[16, 16]} justify="center" align="middle">
          {documentosSinComprobanteIngreso &&
            documentosSinComprobanteIngreso.map((file) => {
              if (file.tipo.split('.')[1] !== 'pdf') {
                return (
                  <Col key={file.url}>
                    <div>
                      <Upload
                        name="avatar"
                        listType="picture-card"
                        className={`avatar-uploader success'`}
                        showUploadList={false}
                        disabled
                      >
                        <Image360
                          style={{
                            width: 'auto !important',
                            borderColor: 'red',
                            height: '40%'
                          }}
                          src={file.url}
                          alt="avatar"
                        />
                      </Upload>
                    </div>
                  </Col>
                );
              }
              return (
                <Col>
                  <CardDocumentPreview360
                    cardProps={{
                      key: file.url,
                      onClick: () => {
                        setDialogConfig({
                          open: true,
                          content: file.url,
                          title: ''
                        });
                      }
                    }}
                    documentProps={{
                      file: file.url,
                      onLoadSuccess: onDocumentLoadSuccess
                    }}
                  />
                </Col>
              );
            })}
          {formularios &&
            formularios.map((file) => {
              return (
                <Col>
                  <CardDocumentPreview360
                    cardProps={{
                      key: file.content,
                      onClick: () => {
                        setDialogConfig({
                          open: true,
                          content: `data:application/pdf;base64,${file.content}`,
                          title: ''
                        });
                      }
                    }}
                    documentProps={{
                      file: `data:application/pdf;base64,${file.content}`,
                      onLoadSuccess: onDocumentLoadSuccess
                    }}
                  />
                </Col>
              );
            })}
        </Row>
        {documentosDeComprobanteIngreso &&
          documentosDeComprobanteIngreso.length > 0 && (
            <>
              <Title level={5} align="left" style={{ marginTop: '20px' }}>
                Comprobantes de Ingresos
              </Title>
              <Row gutter={[16, 16]} justify="center" align="middle">
                {documentosDeComprobanteIngreso &&
                  documentosDeComprobanteIngreso.map((file) => {
                    if (file.tipo.split('.')[1] !== 'pdf') {
                      return (
                        <Col key={file.url}>
                          <div>
                            <Upload
                              name="avatar"
                              listType="picture-card"
                              className={`avatar-uploader success'`}
                              showUploadList={false}
                              disabled
                            >
                              <Image360
                                style={{
                                  width: 'auto !important',
                                  borderColor: 'red',
                                  height: '40%'
                                }}
                                src={file.url}
                                alt="avatar"
                              />
                            </Upload>
                          </div>
                        </Col>
                      );
                    }
                    return (
                      <Col>
                        <CardDocumentPreview360
                          cardProps={{
                            key: file.url,
                            onClick: () => {
                              setDialogConfig({
                                open: true,
                                content: file.url,
                                title: ''
                              });
                            }
                          }}
                          documentProps={{
                            file: file.url,
                            onLoadSuccess: onDocumentLoadSuccess
                          }}
                        />
                      </Col>
                    );
                  })}
              </Row>
            </>
          )}
        {documentosDeFacturasServicios &&
          documentosDeFacturasServicios.length > 0 && (
            <>
              <Title level={5} align="left" style={{ marginTop: '20px' }}>
                Facturas de Servicios
              </Title>
              <Row gutter={[16, 16]} justify="center" align="middle">
                {documentosDeFacturasServicios &&
                  documentosDeFacturasServicios.map((file) => {
                    if (file.tipo.split('.')[1] !== 'pdf') {
                      return (
                        <Col key={file.url}>
                          <div>
                            <Upload
                              name="avatar"
                              listType="picture-card"
                              className={`avatar-uploader success'`}
                              showUploadList={false}
                              disabled
                            >
                              <Image360
                                style={{
                                  width: 'auto !important',
                                  borderColor: 'red',
                                  height: '40%'
                                }}
                                src={file.url}
                                alt="avatar"
                              />
                            </Upload>
                          </div>
                        </Col>
                      );
                    }
                    return (
                      <Col>
                        <CardDocumentPreview360
                          cardProps={{
                            key: file.url,
                            onClick: () => {
                              setDialogConfig({
                                open: true,
                                content: file.url,
                                title: ''
                              });
                            }
                          }}
                          documentProps={{
                            file: file.url,
                            onLoadSuccess: onDocumentLoadSuccess
                          }}
                        />
                      </Col>
                    );
                  })}
              </Row>
            </>
          )}
      </>
    );
  };

  return (
    <>
      {solicitante?.empresaJuridica && (
        <Descriptions
          title="Datos del Asegurado"
          style={{ textAlign: 'left', paddingBottom: 40 }}
          column={{ md: 2, sm: 1, xs: 1 }}
          bordered
          size="small"
        >
          <Descriptions.Item label="Razón Social" span={2}>
            {solicitante?.empresaJuridica?.razon}
          </Descriptions.Item>
          <Descriptions.Item label="CI / RUC">
            {solicitante?.empresaJuridica?.ruc}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección" span={2}>
            {solicitante?.empresaJuridica?.domicilio}
          </Descriptions.Item>
          <Descriptions.Item label="Correo">
            {solicitante?.empresaJuridica?.correo}
          </Descriptions.Item>
        </Descriptions>
      )}
      {!solicitante?.empresaJuridica && (
        <DescripcionesAsegurado solicitante={solicitante} />
      )}

      {solicitud.tercero && (
        <Descriptions
          title="Datos del Tomador / Facturación"
          style={{ textAlign: 'left', paddingBottom: 40 }}
          bordered
          size="small"
          column={{ md: 2, sm: 1, xs: 1 }}
        >
          <Descriptions.Item label="Razón Social">
            {solicitud.tercero.nombres || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="CI / RUC">
            {solicitud.tercero.ruc}
          </Descriptions.Item>
          <Descriptions.Item label="Correo" span={2}>
            {solicitud.tercero.correo}
          </Descriptions.Item>
          <Descriptions.Item label="Departamento">
            {solicitud.tercero?.departamento?.descripcion || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Ciudad">
            {solicitud.tercero?.distrito?.descripcion || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Dirección" span={2}>
            {solicitud.tercero.domicilio}
          </Descriptions.Item>
          <Descriptions.Item label="Celular">
            {solicitud.tercero.celular}
          </Descriptions.Item>
          <Descriptions.Item label="Teléfono (Línea Baja)">
            {solicitud.tercero.telefono}
          </Descriptions.Item>
        </Descriptions>
      )}

      {solicitante?.empresaJuridica && (
        <Descriptions
          title="Datos Personales del REPRESENTANTE LEGAL"
          style={{ textAlign: 'left', paddingBottom: 40 }}
          bordered
          size="small"
          column={{ md: 2, sm: 1, xs: 1 }}
        >
          <Descriptions.Item label="Nombre y Apellido" span={2}>
            {solicitante?.persona?.nombres}
          </Descriptions.Item>
          <Descriptions.Item label="Cédula de Identidad">
            {solicitante?.persona?.cedula}
          </Descriptions.Item>
          <Descriptions.Item label="Domicilio">
            {solicitante?.persona?.domicilio}
          </Descriptions.Item>
          <Descriptions.Item label="Contacto">
            {solicitante?.persona?.celular}
          </Descriptions.Item>
          <Descriptions.Item label="Correo">
            {solicitante?.persona?.correo}
          </Descriptions.Item>
          <Descriptions.Item label="Departamento">
            {solicitante?.persona?.departamento?.descripcion || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Ciudad">
            {solicitante?.persona?.distrito?.descripcion || 'N/A'}
          </Descriptions.Item>
          <Descriptions.Item label="Nacionalidad">
            {solicitante?.persona?.nacionalidad}
          </Descriptions.Item>
          <Descriptions.Item label="Sexo">
            {solicitante?.persona?.sexo}
          </Descriptions.Item>
          <Descriptions.Item label="Estado civil">
            {solicitante?.persona?.estado_civil}
          </Descriptions.Item>
          <Descriptions.Item label="Lugar nacimiento">
            {solicitante?.persona?.lugar_nacimiento}
          </Descriptions.Item>
          <Descriptions.Item label="Fecha nacimiento">
            {solicitante?.persona?.fecha_nacimiento &&
              moment(
                solicitante?.persona?.fecha_nacimiento,
                'YYYY-MM-DD'
              ).format('DD/MM/YYYY')}
          </Descriptions.Item>
        </Descriptions>
      )}
      {solicitud && <DatosProducto />}
      <Descriptions
        title="Compañía y Forma de pago"
        style={{ textAlign: 'left', paddingBottom: 20 }}
        bordered
        size="small"
        column={{ md: 2, sm: 1, xs: 1 }}
      >
        <Descriptions.Item label="Aseguradora">
          {solicitud.cotizacion?.aseguradoraEmpresa?.aseguradora?.descripcion ||
            'N/A'}
        </Descriptions.Item>
        <Descriptions.Item label="Monto">
          {formatoMonedaGenerico(solicitud.moneda, solicitud.monto_total)}
        </Descriptions.Item>
        <Descriptions.Item label="Modalidad de pago" span={2}>
          {solicitud.modalidadPago?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label="Medio de pago" span={2}>
          {solicitud.metodoPago?.descripcion}
        </Descriptions.Item>
        <Descriptions.Item label="Vigencia de pago" span={2}>
          {solicitud.vigenciaPago?.descripcion}
        </Descriptions.Item>
        {solicitud.cotizacion?.vehiculo && (
          <Descriptions.Item label="Forma de pago">
            {
              listaFormaPago.find((item) => item.value === solicitud.forma_pago)
                ?.label
            }
          </Descriptions.Item>
        )}
      </Descriptions>

      <div style={{ marginBottom: 20 }}>
        <DescripcionPlan
          plan={
            getCarouselData(
              getTable(
                [solicitud?.json_plan],
                null,
                null,
                solicitud.producto,
                null,
                true,
                undefined,
                false,
                solicitud.moneda
              )
            )[0]
          }
        />
      </div>

      {solicitud.cotizacion?.aseguradoraEmpresa?.empresa?.seprelad && (
        <Descriptions
          title="Datos Laborales"
          style={{ textAlign: 'left', paddingBottom: 40 }}
          bordered
          size="small"
          column={{ md: 2, sm: 1, xs: 1 }}
        >
          <Descriptions.Item label="RUC">
            {solicitud.cotizacion?.persona?.ruc}
          </Descriptions.Item>
          <Descriptions.Item label="Rango de Ingresos Mensuales Personales (Gs.)">
            {getDescripcionesIngreso(solicitud.cotizacion?.persona?.ingresos)}
          </Descriptions.Item>
          <Descriptions.Item label="¿Es Proveedor del Estado?">
            {solicitud.cotizacion?.persona?.proveedor_estado}
          </Descriptions.Item>
          <Descriptions.Item label="Tipo empleado">
            {solicitud.cotizacion?.persona?.trabajo?.toUpperCase()}
          </Descriptions.Item>
          <Descriptions.Item label="¿Es una Persona Expuesta Políticamente?">
            {solicitud.cotizacion?.persona?.expuesta_politicamente}
          </Descriptions.Item>
          {solicitud.cotizacion?.persona?.institucion_publica && (
            <>
              <Descriptions.Item label="Institución Pública">
                {solicitud.cotizacion?.persona?.institucion_publica || 'N/A'}
              </Descriptions.Item>
              <Descriptions.Item label="Cargo">
                {solicitud.cotizacion?.persona?.institucion_cargo}
              </Descriptions.Item>
              <Descriptions.Item label="Año ingreso">
                {solicitud.cotizacion?.persona?.institucion_anhoingreso}
              </Descriptions.Item>
            </>
          )}
          {(solicitud.cotizacion?.persona?.empleador_ruc !== 'A Confirmar' ||
            solicitud.cotizacion?.persona?.institucion_publica) && (
            <>
              <Descriptions.Item label="RUC Empleador">
                {solicitud.cotizacion?.persona?.empleador_ruc || 'A Confirmar'}
              </Descriptions.Item>
              <Descriptions.Item label="Empresa">
                {solicitud.cotizacion?.persona?.empleador_empresa}
              </Descriptions.Item>
              <Descriptions.Item label="Teléfono">
                {solicitud.cotizacion?.persona?.empleador_telefono ||
                  'A Confirmar'}
              </Descriptions.Item>
              <Descriptions.Item label="Celular">
                {solicitud.cotizacion?.persona?.empleador_celular ||
                  'A Confirmar'}
              </Descriptions.Item>
              <Descriptions.Item label="Dirección">
                {solicitud.cotizacion?.persona?.empleador_direccion}
              </Descriptions.Item>
            </>
          )}
        </Descriptions>
      )}
      {solicitud.cotizacion?.endoso && (
        <Descriptions
          title="Endoso"
          style={{ textAlign: 'left', paddingBottom: 40 }}
          bordered
          size="small"
          column={{ md: 1, sm: 1, xs: 1 }}
        >
          <Descriptions.Item label="Endoso a favor de:">
            {solicitud.cotizacion?.endoso}
          </Descriptions.Item>
        </Descriptions>
      )}
      <PreviewDocumentos />
      <Modal
        bodyStyle={{ padding: 0, paddingBottom: 20 }}
        style={{ maxWidth: 1000 }}
        className="modal-header-document"
        centered
        open={dialogConfig.open}
        afterClose={() =>
          setDialogConfig({
            open: false,
            content: undefined,
            title: ''
          })
        }
        onCancel={() =>
          setDialogConfig({
            open: false,
            content: undefined,
            title: ''
          })
        }
        footer={null}
        width="90%"
      >
        <div>
          {dialogConfig.content && (
            <SizeMe>
              {({ size }) => (
                <Document
                  onLoadSuccess={onDocumentLoadSuccess}
                  loading={<Spin />}
                  file={dialogConfig.content}
                >
                  <Page
                    key={`page_${currentPage + 1}`}
                    pageNumber={currentPage + 1}
                    width={size.width ? size.width : 1}
                  />
                  <div style={{ textAlign: 'center' }}>
                    <Button
                      type="link"
                      onClick={() => previousPage()}
                      disabled={currentPage === 0}
                    >
                      <LeftOutlined />
                      Anterior
                    </Button>
                    Pág. {currentPage + 1} de {numPages}
                    <Button
                      type="link"
                      onClick={() => nextPage()}
                      disabled={currentPage + 1 === numPages}
                    >
                      Siguiente
                      <RightOutlined />
                    </Button>
                  </div>
                </Document>
              )}
            </SizeMe>
          )}
        </div>
      </Modal>
    </>
  );
};

export default Solicitud;
